<template>
	<errorContainer :error="erreur" :warning="warning">
		<b-modal header-class="header-class-modal-doc-package" ref="task-material-modal" v-model="isOpen" size="md" @hidden="onCancel" hide-footer>
			<template #modal-title>
				{{ modalTitle }}
			</template>
			<div class="d-block">
				<task-material-form :material="material" @task-material:updated="materialUpdated" />
			</div>
		</b-modal>
	</errorContainer>
</template>
<script>
import languageMessages from '@/mixins/languageMessages';
import TaskMaterialForm from '@/components/Task/Material/Form';
// import TaskMaterialList from "@/components/Task/Material/List";

export default {
	name: 'TaskMaterialModal',
	mixins: [languageMessages],
	props: {
		value: {
			type: Boolean,
			required: true,
			default: false
		},
		material: {
			type: Object,
			required: true,
			default: null
		}
	},
	computed: {
		isOpen: {
			get() {
				return this.value;
			},
			set(val) {
				return val;
			}
		},
		okTitle() {
			return this.FormMSG(1, 'Ok');
		},
		modalTitle() {
			return this.FormMSG(2, 'Update material') + `: #${this.material.id}`;
		}
	},
	components: {
		TaskMaterialForm
	},
	data() {
		return {
			erreur: {},
			warning: ''
		};
	},
	methods: {
		onCancel() {
			this.$emit('task-material-modal:cancel', false);
		},
		materialUpdated(payload) {
			this.$refs['task-material-modal'].hide();
			this.$emit('task-material-modal:taskMaterialUpdated', payload);
		}
	}
};
</script>
